/**
 * VPN Checker utility using proxycheck.io API
 * Note: Calls backend API to avoid CORS issues with proxycheck.io
 */

import config from '../config';

const API_BASE_URL = config.API_BASE_URL;

/**
 * Check if the user's IP is from a VPN/proxy using proxycheck.io
 * Uses backend API endpoint to proxy the request and avoid CORS
 * @returns {Promise<{isVPN: boolean, ip: string, details: object}>}
 */
export async function checkVPN() {
  try {
    // Call backend API endpoint which will proxy the request to proxycheck.io
    // The backend should handle getting the user's IP and calling proxycheck.io
    const response = await fetch(
      `${API_BASE_URL}/vpn-check`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`VPN check API error: ${response.status} ${response.statusText} - ${errorText}`);
    }

    const data = await response.json();
    
    // Backend should return: { isVPN: boolean, ip: string, details: object }
    return {
      isVPN: data.isVPN || false,
      ip: data.ip || null,
      details: data.details || {},
    };
  } catch (error) {
    console.error('Error checking VPN:', error);
    // On error, we'll allow navigation (fail open) but log the error
    // You might want to change this behavior based on your security requirements
    return {
      isVPN: false,
      ip: null,
      error: error.message,
    };
  }
}
